export default "__VITE_ASSET__8273e8eb__"